import { createContext as t } from "react";
import { s as e } from "./config.mjs";
const s = t({
  editorId: "",
  tabWidth: 2,
  theme: "light",
  language: "zh-CN",
  highlight: {
    css: "",
    js: ""
  },
  showCodeRowNumber: !1,
  usedLanguageText: e["zh-CN"],
  previewTheme: "default",
  customIcon: {},
  rootRef: null
});
export {
  s as E
};
